import styled from 'styled-components';

export const Bottom = styled.section`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #f3e6ff;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  height: 100%;
  margin: 20px 0;
  padding: 20px;
`;

export const ContactWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 500px;
  background-color: #f3e6ff;
`;

export const ContainerContact = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
  flex-wrap: wrap;
  justify-content: center;
 
  p{
    color: #5e17eb;
    font-family: 'Roboto Mono', sans-serif;
  }

  input, textarea {
    outline: 0;
    background-color: #fff;
    border: 0;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 10px;
    font-size: 16px;
    color: #444;
    margin: 10px;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.05);
  }
`;

export const Name = styled.input`
`;

export const Email = styled.input`
`;

export const Message = styled.textarea`
  height: 100px;
  resize: none;
`;

export const Social = styled.div`
  display: flex;
  padding-top: 20px;

  a {
    text-decoration: none;
    padding: 12px;

    svg:hover {
      fill: #b566ff;
    }
  }
`;

export const Button = styled.button`
  background-color: #9c33ff;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  border: 0;
  border-radius: 4px;
  margin: 20px 10px;
  padding: 10px;
  justify-content: stretch;
  transition: .2s ease-in-out;

  &:hover {
    background-color: #b566ff;
  }
`;